import MainWrapper from "@/components/base/MainWrapper";
import StaticPageHeroSection from "@/components/static/StaticPageHeroSection";
import StaticPageCardsSection from "@/components/static/StaticPageCardsSection";
import StaticPageImagesSection from "@/components/static/StaticPageImagesSection";
import StaticPageReviewsSection from "@/components/static/StaticPageReviewsSection";
import StaticPageTextImageSection from "@/components/static/StaticPageTextImageSection";
import HomepageFaqSection from "@/components/homepage/HomepageFaqSection";
import usePreselectLeadFormCity from "@/hooks/usePreselectLeadFormCity";

export default function StaticPage({data, isMobile})
{
    // Set on a city's event page (Corporate Events in {City} and the like), not on other static pages.
    const city = data?.data?.page?.city;
    const pageData = data?.data?.page?.data;

    usePreselectLeadFormCity(city);

    return <div>
        <StaticPageHeroSection
            reviewOverlayData={data?.data?.reviewOverlay}
            heroImages={data?.data?.page?.heroImages}
            title={data?.data?.page?.data?.hero?.title}
            buttonLink={data?.data?.page?.data?.hero?.buttonLink}
            buttonText={data?.data?.page?.data?.hero?.buttonText}
            description={data?.data?.page?.data?.hero?.description}
            dropdownData={pageData?.showDropdown ? pageData?.dropdowns : []}
            breadcrumbs={city ? [
                { title: "Home", link: "/" },
                { title: city.name, link: city.slug },
                { title: pageData?.hero?.title },
            ] : null}
        />

        <StaticPageCardsSection
            cards={[
                {
                    image: data?.data?.page?.card1Image,
                    title: data?.data?.page?.data?.cards?.card_1?.title,
                    description: data?.data?.page?.data?.cards?.card_1?.description,
                    buttonText: data?.data?.page?.data?.cards?.card_1?.buttonText,
                    buttonLink: data?.data?.page?.data?.cards?.card_1?.buttonLink,
                },
                {
                    image: data?.data?.page?.card2Image,
                    title: data?.data?.page?.data?.cards?.card_2?.title,
                    description: data?.data?.page?.data?.cards?.card_2?.description,
                    buttonText: data?.data?.page?.data?.cards?.card_2?.buttonText,
                    buttonLink: data?.data?.page?.data?.cards?.card_2?.buttonLink,
                },
                {
                    image: data?.data?.page?.card3Image,
                    title: data?.data?.page?.data?.cards?.card_3?.title,
                    description: data?.data?.page?.data?.cards?.card_3?.description,
                    buttonText: data?.data?.page?.data?.cards?.card_3?.buttonText,
                    buttonLink: data?.data?.page?.data?.cards?.card_3?.buttonLink,
                },
            ]}
        />

        <div className={'container'}>
            <StaticPageTextImageSection
                textImageSectionImage={data?.data?.page?.textImageSectionImage}
                description={data?.data?.page?.data?.textImageSection?.description}
                buttonLink={data?.data?.page?.data?.textImageSection?.buttonLink}
                buttonText={data?.data?.page?.data?.textImageSection?.buttonText}
            />
        </div>


        <StaticPageImagesSection
            images={data?.data?.page?.galleryImages}
            description={data?.data?.page?.data?.gallery?.description}
        />

        <div
            style={{
                background: 'rgb(235,235,232)',
            }}
        >
            <StaticPageReviewsSection
                reviewText={data?.data?.page?.data?.reviews?.starsText}
                title={data?.data?.page?.data?.reviews?.title}
                description={data?.data?.page?.data?.reviews?.description}
                link={data?.data?.page?.data?.reviews?.buttonLink}
                buttonText={data?.data?.page?.data?.reviews?.buttonText}
            />
        </div>


        {
            data?.data?.page?.data?.faqs?.items && <HomepageFaqSection
                title={data?.data?.page?.data?.faqs?.title ?? ''}
                subtitle={data?.data?.page?.data?.faqs?.description ?? ''}
                faqs={data?.data?.page?.data?.faqs?.items ?? []}
            />
        }
    </div>
}
